import { render, staticRenderFns } from "./SettingsSalary.vue?vue&type=template&id=77dc7aaa&scoped=true&"
import script from "./SettingsSalary.vue?vue&type=script&lang=js&"
export * from "./SettingsSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dc7aaa",
  null
  
)

export default component.exports